import { CSSProperties, FC, ReactNode } from 'react';
import { Avatar, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

interface AccessStateSectionProps {
    icon: ReactNode;
    label: ReactNode;
    description: ReactNode;
    extra?: ReactNode;
    height?: CSSProperties['height'];
    maxWidth?: CSSProperties['maxWidth'];
    style?: CSSProperties;
}

const AccessStateSection: FC<AccessStateSectionProps> = ({
    icon,
    label,
    description,
    extra,
    height,
    maxWidth = '22rem',
    style,
}) => {
    const { token } = useAntDesignTheme();

    return (
        <section
            style={{
                textAlign: 'center',
                height,
                ...(height ? centerComponentInMiddleofView : {}),
                ...style,
            }}
        >
            <Avatar
                shape='square'
                size={16 * 2.5}
                style={{
                    border: `1px solid ${token.colorBorder}`,
                    backgroundColor: token.colorBgContainer,
                    marginBottom: '0.75rem',
                }}
                icon={icon}
            />
            <Typography.Title level={5} style={{ marginBottom: '0.375rem' }}>
                {label}
            </Typography.Title>
            <div style={{ maxWidth, margin: '0 auto' }}>
                <Typography.Text type='secondary'>{description}</Typography.Text>
            </div>
            {extra && <div style={{ marginTop: '1rem' }}>{extra}</div>}
        </section>
    );
};

export default AccessStateSection;
